<script>
  import Hero from "$lib/components/Hero/Hero.svelte";
  import PageBody from "$lib/components/Page/PageBody.svelte";
  import ItemPreviewList from "$lib/contentTypes/ItemPreviewList.svelte";

  export let page;
  const parentInfo = page.fields.pageData.fields.parentInfo;
  let eyebrow = {};
  // Page is for a family, eyebrow should display family name with no link
  if (parentInfo?.relativeUrl === "/") {
    eyebrow.content = page.fields.pageData.fields.headline;
  }
</script>

<div class="w-full px-24 md:px-175 lg:max-w-1014 lg:px-0 m-auto">
  <Hero
    title={page.fields.pageData.fields.headline}
    featuredImage={page.fields.featuredImageComponent}
    {eyebrow}
    {parentInfo}
  />

  <div class="w-auto page-level-padding internal-page-spacing">
    <!--
      TODO: When all category pages have been created/before launch, 
      this should no longer be conditional. A missing body should
      ultimately create a build error. 
    -->
    {#if page.fields.body}
      <div>
        <PageBody
          body={page.fields.body}
          class={page.fields.itemPreviewLists || page.fields.trailingBody
            ? ""
            : "last-page-element"}
        />
      </div>
    {/if}

    {#if page.fields.itemPreviewLists}
      <div class={page.fields.trailingBody ? "" : "last-page-element"}>
        {#each page.fields.itemPreviewLists as listData}
          <div data-headings-increment>
            <!-- div added so that the gap doesn't double add spacing under the section header. -->
            <ItemPreviewList data={listData} />
          </div>
        {/each}
      </div>
    {/if}

    {#if page.fields.trailingBody}
      <PageBody body={page.fields.trailingBody} class="last-page-element" />
    {/if}
  </div>
</div>
